import Client from '@/repositories/Clients/AxiosClient';
import Config from '@/repositories/Clients/AxiosDefaultConfig';

const resource = `${Config.basePath}/report/overview`;

export default {
  index(payload) {
    return Client.get(`${resource}`, {
      params: payload,
    });
  },
};
